var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoteOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 42 42",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.781 13.781 17.062 31.5h-6.563v-6.563L28.218 7.218zm2.215-2.215-6.563-6.563 2.299-2.299a1.974 1.974 0 0 1 2.784 0l3.778 3.778a1.974 1.974 0 0 1 0 2.784zM31.5 23.116V36.75H5.25V10.5h14.438l5.25-5.25h-21A3.95 3.95 0 0 0 0 9.188v28.875a3.95 3.95 0 0 0 3.938 3.938h28.875a3.95 3.95 0 0 0 3.938-3.938V18.402l-5.25 4.715z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "red",
    strokeMiterlimit: 10,
    d: "M0 0h42v42H0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoteOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/note-on.svg";